module.exports = __webpack_public_path__ + "static/media/restart.e1b85329.svg";